import { FieldValues, Path, UseFormReturn } from "react-hook-form";
import { AddressFormFieldControl } from "../../../api";
import { FormComponent } from "../../form";
import { FormAddressAutocomplete } from "../../form/fields";

type ContactAddressFieldProps<TFieldValues extends FieldValues & { address?: unknown }> = {
	formMethods: UseFormReturn<TFieldValues, any, any>;
	addressControl: AddressFormFieldControl;
	partialRequiresSubmit?: boolean;
	/** Defaults to `false`. */
	compact?: boolean;
};

// "address" is cast to Path<TFieldValues>: the constraint guarantees the field, but TS can't
// prove a literal is a member of the recursive Path type for an abstract generic.
export const ContactAddressField = <TFieldValues extends FieldValues & { address?: unknown }>({
	formMethods,
	addressControl,
	partialRequiresSubmit,
	compact = false,
}: ContactAddressFieldProps<TFieldValues>) => (
	<FormComponent
		formMethods={formMethods}
		name={"address" as Path<TFieldValues>}
		label="Address"
		inline
		partialRequiresSubmit={partialRequiresSubmit}
	>
		<FormAddressAutocomplete control={addressControl} compact={compact} />
	</FormComponent>
);
